import { LoadPanel, Popup } from 'devextreme-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { DxReportViewer, PreviewElements } from 'devexpress-reporting/dx-webdocumentviewer';
import * as ko from 'knockout';
import { ReportStruct, ReportType } from '../../../types/types.reports';
import { UseApiResults } from '../../../api/api.results';
import { ResultEstadoResult, SysIResultados } from '../../../types/types.orders';
import { newToast } from '../..';
import deCore from '../../../localization/dx-analytics-core.es.json';
import deRep from '../../../localization/dx-reporting.es.json';

export const ModalReportResults = ({ idOrd, visible, setVisible, reportName, studies }: { idOrd: number; visible: boolean; setVisible: ({ visible }) => void; reportName: string; studies?: number[] }) => {
  const viewerRef = useRef<HTMLDivElement>(null);
  const { putPrintResultFromSearch } = UseApiResults();
  const [loading, setLoading] = useState<boolean>(false);
  const [requestOptions, setRequestOptions] = useState({
    host: '',
    invokeAction: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/config.json');
        const data = await response.json();
        // const resCurrentResult = await getResults(idOrd);
        // const myData: SysIResultados[] = resCurrentResult as SysIResultados[];
        // if (myData.filter((x) => x.Res_Estado >= ResultEstadoResult.Validado).length === 0) {
        //   handleVisible();
        //   newToast('INFO', 'No hay analitos validados para la orden seleccionada', 5);
        //   return;
        //} else {
        setRequestOptions({ host: `${data.apiUrl}/`, invokeAction: 'DXXRDV' });
        //}
      } catch (error) {
        console.error('Error fetching config data:', error);
      }
    };
    if (visible) {
      fetchData();
    }
  }, [visible]);

  useEffect(() => {
    if (!viewerRef.current || idOrd === -1 || !requestOptions.host || !visible) {
      return;
    }

    const myReport: ReportStruct = { Name: reportName, Type: ReportType.System, Data: [idOrd], Studies: studies };
    const reportUrl = ko.observable(JSON.stringify(myReport));
    const viewer = new DxReportViewer(viewerRef.current, {
      reportUrl,
      requestOptions,
      callbacks: {
        CustomizeMenuActions: (s, e) => {
          var search = e.Actions.find((x) => x.id === 'dxxrp-search');
          if (search) {
            search.visible = false;
          }
          var editingFields = e.Actions.find((x) => x.id === 'dxxrp-highlight-editing-fields');
          if (editingFields) {
            editingFields.visible = false;
          }

          var exportMenu = e.Actions.find((x) => x.id === 'dxxrp-export-menu');
          if (exportMenu) {
            exportMenu.visible = false;
          }

          var printPage = e.Actions.find((x) => x.id === 'dxxrp-print-page');
          if (printPage) {
            printPage.visible = false;
          }

          var print = e.Actions.find((x) => x.id === 'dxxrp-print');
          if (print) {
            var originalClickAction = print.clickAction;
            print.clickAction = () => {
              setLoading(true);              
              putPrintResultFromSearch(idOrd, studies || [])
                .then((res) => {
                  setLoading(false);
                  if (res) {
                    originalClickAction();
                  }
                })
                .catch((err) => {
                  console.error('Error al imprimir resultados:', err);
                  setLoading(false);
                  newToast('ERROR', 'Error al imprimir resultados', 5);
                });
            };
          }
        },
        CustomizeExportOptions: (s, e) => {
          e.HideExportOptionsPanel();
        },

        CustomizeLocalization: (s, e) => {
          e.LoadMessages(deCore);
          e.LoadMessages(deRep);
          s.UpdateLocalization({
            'Preview Parameters': 'Parámetros',
            Reset: 'Limpiar',
          });
        },
      },
    });
    viewer.render();
    return () => viewer.dispose();
  }, [idOrd, requestOptions]);

  const handleVisible = useCallback(() => {
    setVisible({ visible: false });
  }, []);

  return (
    <Popup visible={visible} fullScreen={true} onHidden={handleVisible} title='Reporte de resultados' showCloseButton={true}>
      <LoadPanel visible={loading} />
      <div style={{ width: '100%', height: '100%' }}>
        <div ref={viewerRef}></div>
      </div>
    </Popup>
  );
};
